module.exports = __webpack_public_path__ + "static/media/thumb.038d6b49.jpg";